import {I_ACCESS_TOKEN_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import { I_PREF_ALERT } from '../interfaces/I_ALERTS';
import APP_CONFIG from 'config';


// ---------------------------------
// --- Alertes
// ---------------------------------

const ENDPOINT_ALERTS = '/alerts';
const ENDPOINT_ALERTS_PREFS = '/alerts_preferences';
const ENDPOINT_ALERTS_ACQ = '/alerts_acknowledge';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  user_id: number;
}
/**
 * Requete le endpoint
 * Récupère la liste des alertes
 * @param param0
 */
const get = async ({accessToken,user_id}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - alerts - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_ALERTS}/${user_id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint
 * Récupère la liste des preferences d'alertes
 * @param param0
 */
const getPref = async ({
  accessToken,
  user_id,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - alerts - getPref...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_ALERTS_PREFS}/${user_id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_POST_PARAMS {
  accessToken: string;
  user_id: number;
  preferences: I_PREF_ALERT[];
}
/**
 * Requete le endpoint  POST
 * Ajoute une preference d'alerte
 * @param param0
 * @returns
 */
export const setPref = async ({
  accessToken,
  user_id,
  preferences,
}:I_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - alerts - setPref...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify(preferences),
  };
  const URL = `${ENDPOINT_ALERTS_PREFS}/${user_id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

interface I_ACQ_POST_PARAMS {
  accessToken: string;
  user_id: number;
  alert_id: number;
}
/**
 * Requete le endpoint  POST
 * Acquitte une alerte
 * @param param0
 * @returns
 */
export const acknowledge = async ({
  accessToken,
  user_id,
  alert_id,
}:I_ACQ_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - alerts - acknowledge...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
  };
  const URL = `${ENDPOINT_ALERTS_ACQ}/${user_id}/${alert_id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


const AlertsEndpoints = {
  get,
  getPref,
  setPref,
  acknowledge,
};

export default AlertsEndpoints;
